<div class="vt-page">
  @if(!langChangeInProgress()){
  <router-outlet></router-outlet>
  }
</div>
